import { render, staticRenderFns } from "./passenger-form.vue?vue&type=template&id=36f4a3c0&scoped=true"
import script from "./passenger-form.vue?vue&type=script&lang=js"
export * from "./passenger-form.vue?vue&type=script&lang=js"
import style0 from "./passenger-form.vue?vue&type=style&index=0&id=36f4a3c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f4a3c0",
  null
  
)

export default component.exports